import type { UUID } from "../../../utils/uuid";
import { useClaims } from "./use-claims";

export const useAccountId = (): UUID | undefined => {
  const claims = useClaims();
  return claims?.["http://changeengine.com/account_id"];
};
